import { render, staticRenderFns } from "./TabsRightType.vue?vue&type=template&id=2415bd44&scoped=true"
import script from "./TabsRightType.vue?vue&type=script&lang=js"
export * from "./TabsRightType.vue?vue&type=script&lang=js"
import style0 from "./TabsRightType.vue?vue&type=style&index=0&id=2415bd44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2415bd44",
  null
  
)

export default component.exports